import { jsx as r } from "react/jsx-runtime";
import T from "clsx";
import { C as g, S as x } from "./helpers-458d7e27.js";
import { D as M, M as f, i as u, T as A } from "./TextHeaderInner-7887aa3a.js";
import "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const E = {
  "8 Col Center": { start: 3, span: 8 },
  "12 Col Start to End": { start: 1, span: 12 },
  "5 Col Start to Middle": { start: 1, span: 5 },
  "6 Col Start to Middle": { start: 1, span: 6 },
  "7 Col Start to Middle": { start: 1, span: 7 },
  "5 Col to End": { start: 8, span: 5 },
  "6 Col Middle to End": { start: 7, span: 6 },
  "7 Col to End": { start: 6, span: 7 }
}, O = (t) => E[t] ?? {
  start: M,
  span: f
};
const a = "TextSection", o = new g(a), _ = ({
  textGroup: t,
  className: i = "",
  theme: p = "white",
  alignment: s = "8 Col Center",
  topSpacer: l = "4vw",
  bottomSpacer: m = "4vw",
  disclosureType: c,
  componentId: C,
  variant: n = "default",
  ...d
}) => {
  const S = T(i, o.getComponentClassName(), {
    [o.getPropsValueClassName("variant", n)]: n !== "default"
  }), N = s === "8 Col Center";
  let e = t;
  return u(t) || (e = {
    ...O(s),
    textGroup: t
  }), /* @__PURE__ */ r(
    x,
    {
      className: S,
      theme: p,
      options: { topSpacing: l, bottomSpacing: m },
      disclosure: c,
      id: C,
      ...d,
      children: /* @__PURE__ */ r(
        A,
        {
          className: o.getPropsValueClassName("alignment", s),
          ...e,
          textGroup: {
            ...e.textGroup,
            analyticsCompName: a,
            alignment: N ? "Center" : "Start"
          }
        }
      )
    }
  );
};
_.displayName = a;
export {
  _ as default
};
//# sourceMappingURL=TextSectionType.js.map
